import {createStore} from 'vuex'
import iframe from './iframe'
import registration from './registration'

export default createStore({
    modules: {iframe, registration},
})
